module.exports = __webpack_public_path__ + "img/patients-icon.7b46f078.svg";